import { render } from "./ConfigureVasionSettings.vue?vue&type=template&id=442fb1f4&scoped=true"
import script from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"

import "./ConfigureVasionSettings.vue?vue&type=style&index=0&id=442fb1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442fb1f4"]])

export default __exports__